<template>
  <g>
    <circle cx="12.0001" cy="12.0001" r="10.2857" />
  </g>
</template>
